import { Observable, Subject } from 'rxjs';
import { filter, map } from 'rxjs/operators';

export class Evented<TEvents extends { [name: string]: any }> {
  private readonly _event$ = new Subject<any>();
  private readonly _events = new Map<any, Observable<any>>();

  private readonly _eventedParents = new Set<Evented<any>>();

  public on<TType extends keyof TEvents>(type: TType): Observable<TEvents[TType]> {
    if (this._events.has(type)) {
      return this._events.get(type);
    }

    const subscription$ = this._event$.pipe(
      filter((targetEvent) => targetEvent.type === type),
      map((targetEvent) => targetEvent.event),
    );

    this._events.set(type, subscription$);

    return subscription$;
  }

  public off(): this {
    this._event$.complete();
    return this;
  }

  // FIXME need to find way for emiting events in angular zone
  public fire<TType extends keyof TEvents>(
    type: TType,
    event?: TEvents[TType],
    propagate: boolean = false,
  ): this {
    this._event$.next({ type, event });

    if (propagate) {
      this._eventedParents.forEach((parent) => {
        parent.fire(type, {
          targetElement: this,
          targetEvent: event,
        });
      });
    }

    return this;
  }

  public addEventedParent(object: Evented<any>): this {
    this._eventedParents.add(object);

    return this;
  }

  public removeEventedParent(object: Evented<any>): this {
    this._eventedParents.delete(object);

    return this;
  }
}
